// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import router from './router'
import {i18n} from "./utils/i18n.js"
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import {
  store
} from './store'
import axios from 'axios'

import fullCalendar from 'vue-fullcalendar'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import DaySpanVuetify from 'dayspan-vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import 'font-awesome/css/font-awesome.min.css' // Ensure you are using css-loader
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
// import { faBars } from '@fortawesome/pro-light-svg-icons'
import { faVuejs } from '@fortawesome/free-brands-svg-icons'

import 'vuetify/dist/vuetify.min.css'
import 'dayspan-vuetify/dist/lib/dayspan-vuetify.min.css'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faVuejs)
Vue.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
library.add(fas) // Include needed icons.
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.use(VueRouter)

Vue.use(VueChartkick, {
  adapter: Chart
})
Vue.component('full-calendar', fullCalendar)
Vue.use(Vuetify, {
  iconfont: 'md'
})
Vue.use(Vuetify, {
  iconfont: 'mdi'
})
Vue.use(Vuetify, {
  iconfont: 'fa'
})
Vue.use(Vuetify, {
  iconfont: 'fa4'
})
Vue.use(Vuetify, {
  iconfont: 'faSvg'
})
Vue.use(Vuetify, {
  theme: {
    primary: '#0051a0',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  iconfont: 'fa'
})

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(DaySpanVuetify, {
  methods: {
    getDefaultEventColor: () => '#1976d2'
  }
})

window.Store = store

var PulseLoader = require('vue-spinner/src/PulseLoader.vue');


new Vue({
  el: '#app',
  i18n,
  router,
  store,
  axios,
  components: {
    App
  },
  methods:{
      getDaisableDate(val){
          var cdate  = new Date()
          cdate.setFullYear(cdate.getFullYear()-val)
          var disabelDate=cdate.getFullYear()+'-'
                  +('0' + (cdate.getMonth()+1)).slice(-2) + '-'
                  +('0' + (cdate.getDate()+1)).slice(-2)
          return disabelDate
      }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js